import React from "react";
import styled from "styled-components";
import { Flex } from "./FlexBox";

const Container = styled(Flex)`
  width: 100%;
  height: 30px;
  border-radius: 30px;
  border: 1px solid #eee;
  align-items: center;
  overflow: hidden;
`;

const Loading = styled(Flex)`
  height: 110%;
  border-radius: 30px;
  background-color: #01b17a;
`;

const Missing = styled(Flex)`
  height: 100%;
  border-radius: 10px;
`;

const StatusBar = ({ children, className, width }) => {
  return (
    <Container>
      <Loading className={className} width={width} />
      <Missing />
    </Container>
  );
};

export default StatusBar;
